import React from 'react';
import { useSelector } from 'react-redux';

import { getDisplayTotal } from '@/components/route/search/AlertMessage/noResultsFilters';
import { EPage, PAGE_PATHNAME } from '@/constants/pages';
import { useRouter } from '@/hooks/useRouter';
import { TRootState } from '@/redux/rootReducer';
import { getQueryParams, TQueryParams } from '@/redux/selectors/queryParams';

import SearchPreviewResults, { TFilterPreviewState } from './SearchPreviewResults';

interface IProps {
  onSubmit?: () => void;
  isDisabled?: boolean;
}

const SearchPreviewResultsContainer: React.FC<IProps> = props => {
  const router = useRouter();
  const isCampgroundsSearchPage = router?.pathname?.includes(
    PAGE_PATHNAME[EPage.CAMPGROUND_SEARCH],
  );
  const isOneWaySearchPage = router?.pathname === PAGE_PATHNAME[EPage.ONE_WAY_SEARCH];

  // On the one-way SRP the modal preview reads from the oneWaySearch slice's
  // meta state (populated by fetchOneWayMetaResults). Everywhere else, fall
  // back to the existing rental/campground meta flow on state.search.
  const oneWayMeta = useSelector((s: TRootState) => s.oneWaySearch.meta);
  const { isMetaLoading, errorMeta, metaPreview } = useSelector<TRootState, TRootState['search']>(
    s => s.search,
  );
  const queryParams = useSelector(getQueryParams);
  const formFilters = useSelector((s: TRootState) => s.searchForm.filters);

  let state: TFilterPreviewState = 'idle';
  let total: number | null = null;

  if (isOneWaySearchPage) {
    if (oneWayMeta.loading) state = 'loading';
    if (oneWayMeta.error) state = 'error';
    total = oneWayMeta.total;
  } else {
    if (isMetaLoading) state = 'loading';
    if (errorMeta) state = 'error';
    // Same query the preview request is built from, so pending modal filters drop back to the card count.
    const previewQuery = { ...queryParams, ...formFilters } as TQueryParams;
    total =
      metaPreview?.total !== undefined
        ? getDisplayTotal(previewQuery, metaPreview.total, metaPreview.total_units)
        : null;
  }

  return (
    <SearchPreviewResults
      {...props}
      state={state}
      total={total}
      isCampgroundsSearchPage={isCampgroundsSearchPage}
    />
  );
};

export default SearchPreviewResultsContainer;
